<template>
<div class="chapter">
<div class="inner_page">
<h1 class="chapter">Table of Contents</h1>
<p class="toc"><a href="#/OEBPS/cvi.htm">Cover</a></p>
<p class="toc" id="also"><a href="#/OEBPS/also.htm">Also by Yan Lianke</a></p>
<p class="toc"><a href="#/OEBPS/tp.htm">Title Page</a></p>
<p class="toc"><a href="#/OEBPS/cop.htm">Copyright</a></p>
<p class="toc" id="fm"><a href="#/OEBPS/fm.htm">Translator’s Note</a></p>
<p class="toc" id="c01"><a href="#/OEBPS/c01.htm">CHAPTER 1: Prefatory Material</a></p>
<p class="toc" id="c02"><a href="#/OEBPS/c02.htm">CHAPTER 2: Geographic Transformation (1)</a></p>
<p class="toc" id="c03"><a href="#/OEBPS/c03.htm">CHAPTER 3: Year One of the Revolution</a></p>
<p class="toc" id="c04"><a href="#/OEBPS/c04.htm">CHAPTER 4: Revolutionary Biographies</a></p>
<p class="toc" id="c05"><a href="#/OEBPS/c05.htm">CHAPTER 5: Political Power (1)</a></p>
<p class="toc" id="c06"><a href="#/OEBPS/c06.htm">CHAPTER 6: Traditional Customs</a></p>
<p class="toc" id="c07"><a href="#/OEBPS/c07.htm">CHAPTER 7: Political Power (2)</a></p>
<p class="toc" id="c08"><a href="#/OEBPS/c08.htm">CHAPTER 8: Integrated Economy</a></p>
<p class="toc" id="c09"><a href="#/OEBPS/c09.htm">CHAPTER 9: Nature</a></p>
<p class="toc" id="c10"><a href="#/OEBPS/c10.htm">CHAPTER 10: Structural Transformation</a></p>
<p class="toc" id="c11"><a href="#/OEBPS/c11.htm">CHAPTER 11: Assessment of the New Era</a></p>
<p class="toc" id="c12"><a href="#/OEBPS/c12.htm">CHAPTER 12: National Defense</a></p>
<p class="toc" id="c13"><a href="#/OEBPS/c13.htm">CHAPTER 13: The Post-Military Era</a></p>
<p class="toc" id="c14"><a href="#/OEBPS/c14.htm">CHAPTER 14: Geographic Transformation (2)</a></p>
<p class="toc" id="c15"><a href="#/OEBPS/c15.htm">CHAPTER 15: Culture, Cultural Relics, and History</a></p>
<p class="toc" id="c16"><a href="#/OEBPS/c16.htm">CHAPTER 16: New Members of the Clan</a></p>
<p class="toc" id="c17"><a href="#/OEBPS/c17.htm">CHAPTER 17: Great Geographic Transformation (1)</a></p>
<p class="toc" id="c18"><a href="#/OEBPS/c18.htm">CHAPTER 18: Great Geographic Transformation (2)</a></p>
<p class="toc" id="c19"><a href="#/OEBPS/c19.htm">CHAPTER 19: Postface</a></p>
<p class="toc" id="aun"><a href="#/OEBPS/aun.htm">Author’s Note</a></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// toc.vue?c2bc83aa